import { RemoteObject } from './remote-object.model';
import { SPHApplication } from '../shared';

// tslint:disable:variable-name

export class SPHPhone extends RemoteObject {
    public static fromJSON(json: any): SPHPhone {
        const phone = new SPHPhone();

        Object.getOwnPropertyNames(phone).forEach( (propertyName) => {
            if (
                (propertyName === 'createdAt' ||
                propertyName === 'updatedAt' ||
                propertyName === 'last_send') && json[propertyName] !== null) {
                phone[propertyName] = new Date(json[propertyName]);
            } else {
                phone[propertyName] = json[propertyName];
            }
         });

        return phone;
    }

    public license_id: number = undefined;
    public devicename: string = undefined;
    public device_model: string = undefined;
    public identnr: string = undefined;
    public os: string = undefined;
    public os_version: string = undefined;
    public application: SPHApplication = undefined;
    public token: string = undefined;
    public lock: boolean = undefined;
    public published: boolean = undefined;

    public toJSON(): any {
        const json = {};
        this.remoteObjectCommonsToJson(json);
        Object.getOwnPropertyNames(this).forEach( (propertyName) => {
            json[propertyName] = this[propertyName];
        });
        return json;
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/sph-phone.model.ts